import type { components } from "@/src/api/api";

/**
 * Un compte, vu par l'administration.
 *
 * ⚠️ **C'est la seule forme de l'API qui porte un e-mail, des rôles et une
 * position pour quelqu'un d'autre que soi.** Partout ailleurs, un compte tiers
 * se réduit à un pseudo et un avatar. Ce qui s'affiche ici ne doit donc jamais
 * ressortir dans un composant partagé avec le reste de l'admin.
 */
export type AdminAccount = components["schemas"]["AdminAccountSchemaOutput"];

/** La fiche complète : le compte, son profil public, ses armées, ses compteurs. */
export type AdminAccountDetail = NonNullable<
  components["schemas"]["GetAdminAccountApiResponseSchema"]["data"]
>;

export type AccountCounters = AdminAccountDetail["counters"];

/** Les deux tris que le serveur sait faire. */
export const SORTS = ["createdAt", "username"] as const;

export type AccountSort = (typeof SORTS)[number];

export function isAccountSort(value: unknown): value is AccountSort {
  return SORTS.some((sort) => sort === value);
}

export const ORDERS = ["desc", "asc"] as const;

export type AccountOrder = (typeof ORDERS)[number];

export function isAccountOrder(value: unknown): value is AccountOrder {
  return ORDERS.some((order) => order === value);
}

/**
 * Cinquante par page.
 *
 * Le serveur plafonne à cent ; cinquante tient sur un écran d'admin sans
 * demander de faire défiler la page entière avant d'atteindre la pagination.
 */
export const PAGE_SIZE = 50;
